import z from "zod";
import { createCommonApiResponseSchema } from "@/server/agentTypes";

export const SelectedProductsSchema = z.array(
  z.object({
    id: z.string(),
    typeId: z.string().optional(),
    name: z.string().optional(),
    amount: z.number().optional(),
    prefixAgreeText: z.string(),
    formPageIds: z.array(z.string()),
    agreeTypeCombination: z.string(),
    blockTitle: z.string(),
    blockText: z.string(),
    showBlock: z.boolean(),
    blockCheckboxLabel: z.string(),
    showCheckboxAgree: z.boolean(),
    groupOrder: z.number(),
  })
);

export const SelectAndActualizeResponseSchema = createCommonApiResponseSchema(
  z.object({
    selectedProducts: SelectedProductsSchema,
  })
);

export const SelectAndActualizeByAmountResponseSchema =
  createCommonApiResponseSchema(
    z.object({
      selectedProducts: SelectedProductsSchema,
      selectedProductsByAmount: SelectedProductsSchema,
    })
  );

export const RedirectToLkResponseSchema = createCommonApiResponseSchema(
  z.object({
    redirectUrl: z.string(),
  })
);

export const GetInnVerificationResponseSchema = createCommonApiResponseSchema(
  z.object({
    inn: z.string().optional(),
  })
);
